import { ObjectStorage } from 'shared/api/object-storage';
const default_settings = {
    widget_device_ids: [],
    pin: null,
    require_fingerprint: false,
    push_sound: {
        remote_id: null,
        local_id: null,
        title: null,
    },
};
// preserving settings in old format
if (ObjectStorage.get(window.localStorage, 'widget_device_ids') != null &&
    !ObjectStorage.get(window.localStorage, 'app_settings')) {
    ObjectStorage.set(window.localStorage, 'app_settings', {
        ...default_settings,
        widget_device_ids: ObjectStorage.get(window.localStorage, 'widget_device_ids'),
    });
    ObjectStorage.del(window.localStorage, 'widget_device_ids');
}
const initial = {
    dialog_open: false,
    opened_ask_pin_dialog: false,
    opened_set_pin_dialog: false,
    opened_pin_dont_match_dialog: false,
    error: null,
    settings: ObjectStorage.get(window.localStorage, 'app_settings') ?? default_settings,
};
export const reducer = (state = initial, action) => {
    switch (action.type) {
        case 'UPDATE_APP_SETTINGS': {
            const new_settings = { ...state.settings, ...action.setter };
            ObjectStorage.set(window.localStorage, 'app_settings', new_settings);
            return { ...state, settings: new_settings };
        }
        case 'APP_SETTINGS__WIDGETS_ENABLE_FOR_DEVICE': {
            let new_widget_ids;
            if (action.enable ===
                state.settings.widget_device_ids.includes(action.device_id))
                new_widget_ids = state.settings.widget_device_ids;
            else if (action.enable)
                new_widget_ids = [
                    ...state.settings.widget_device_ids,
                    action.device_id,
                ];
            else
                new_widget_ids = state.settings.widget_device_ids.filter((id) => id !== action.device_id);
            const new_settings = {
                ...state.settings,
                widget_device_ids: new_widget_ids,
            };
            ObjectStorage.set(window.localStorage, 'app_settings', new_settings);
            return { ...state, settings: new_settings };
        }
        case 'APP_SETTINGS__OPEN_ASK_DIALOG':
            return { ...state, opened_ask_pin_dialog: true };
        case 'APP_SETTINGS__CLOSE_ASK_DIALOG':
            return { ...state, opened_ask_pin_dialog: false };
        case 'APP_SETTINGS__OPEN_SET_DIALOG':
            return { ...state, opened_set_pin_dialog: true };
        case 'APP_SETTINGS__CLOSE_SET_DIALOG':
            return { ...state, opened_set_pin_dialog: false };
        case 'APP_SETTINGS__OPEN_DONT_MATCH_DIALOG':
            return { ...state, opened_pin_dont_match_dialog: true };
        case 'APP_SETTINGS__CLOSE_DONT_MATCH_DIALOG':
            return { ...state, opened_pin_dont_match_dialog: false };
        default:
            return state;
    }
};
